import React from 'react';
import { cn } from '../../../lib/utils';
import { EntryMode } from './interface';

// ─── Tab Button (view switcher) ────────────────────────────────────────────────

export function TabButton({
  active, onClick, icon, label,
}: {
  active: boolean; onClick: () => void; icon: React.ReactNode; label: string;
}) {
  return (
    <button
      onClick={onClick}
      className={cn(
        'flex items-center gap-2 px-4 py-1.5 rounded-md text-sm font-medium transition-colors',
        active ? 'bg-white dark:bg-slate-900 shadow-sm text-slate-900 dark:text-white' : 'text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-200',
      )}
    >
      {icon}
      {label}
    </button>
  );
}

// ─── Small pill toggle (Quick Hours / From-To, inside the edit dialog) ────────

export function ModeToggle({ mode, onChange }: { mode: EntryMode; onChange: (m: EntryMode) => void }) {
  return (
    <div className="flex items-center gap-1 bg-slate-100 dark:bg-slate-800 p-1 rounded-lg w-fit mb-1">
      <button
        type="button"
        onClick={() => onChange('quick')}
        className={cn(
          'px-3 py-1.5 rounded-md text-xs font-medium transition-all',
          mode === 'quick' ? 'bg-white dark:bg-slate-700 shadow-sm text-indigo-700 dark:text-indigo-400' : 'text-slate-500 dark:text-slate-400',
        )}
      >
        Quick Hours
      </button>
      <button
        type="button"
        onClick={() => onChange('range')}
        className={cn(
          'px-3 py-1.5 rounded-md text-xs font-medium transition-all',
          mode === 'range' ? 'bg-white dark:bg-slate-700 shadow-sm text-indigo-700 dark:text-indigo-400' : 'text-slate-500 dark:text-slate-400',
        )}
      >
        From / To
      </button>
    </div>
  );
}
